export default __webpack_public_path__ + "assets/ghost.600dd2.svg";